export enum LogMethod {
  LogMessage = 'log',
  InfoMessage = 'info',
  WarnMessage = 'warn',
  ErrorMessage = 'error'
}
